import './headerTab.scss';
interface ImageInterface {
    title: string;
    file: {
        url: string;
    };
    gatsbyImageData?: any;
}
interface TabInterface {
    imagen: ImageInterface[];
    redireccion: string;
    copyBoton: string;
}

interface HeaderTabInterface {
    tabContent: TabInterface;
    isTabActive: boolean;
    handleClick: () => void;
    isWhite?: boolean;
}

const HeaderTab = (props: HeaderTabInterface) => {
    return (
        <div
            className={`${props.isTabActive ? 'a-tab a-tab--active' : 'a-tab'}`}
            onClick={props.handleClick}
        >
            <div
                className={`${
                    props.isTabActive
                        ? 'a-tab__content a-tab__content--active'
                        : 'a-tab__content'
                }${props.isWhite ? '__white' : ''}`}
            >
                <img
                    src={props.tabContent.imagen[0].file.url}
                    alt={`Icono ${props.tabContent.copyBoton}`}
                    title={`Icono ${props.tabContent.copyBoton}`}
                />
                <p>{props.tabContent.copyBoton.toLowerCase()}</p>
            </div>
        </div>
    );
};

export default HeaderTab;
